// import React, { useState, useEffect } from "react";
// import {
//   View,
//   StyleSheet,
//   StatusBar,
//   Text,
//   Image,
//   ScrollView,
//   TouchableOpacity,
//   RefreshControl,
//   ImageBackground,
// } from "react-native";
// import { useFocusEffect } from "@react-navigation/native";
// import { Colors, Dim } from "../../../constants/Theme";
// import { Fonts } from "../../../constants/fonts";
// import Entypo from "react-native-vector-icons/Entypo";

// import { useSelector, useDispatch } from "react-redux";
// import { getUserAllSubscriptions } from "../../../services/user.services";
// import { SELECTED_TEAM } from "../../../redux/actions/team.actions";

// const SelectTeam = (props) => {
//   const dispatch = useDispatch();

//   const [teamData, setTeamData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const user = useSelector((state) => state.authReducer.user);
//   const selectedTeam = useSelector((state) => state.teamReducer.selectedTeam);

//   const handleGetAllTeams = async () => {
//     try {
//       setLoading(true);
//       const response = await getUserAllSubscriptions(
//         { userId: user._id },
//         user?.token
//       );
//       setTeamData(response.data);
//     } catch (error) {
//     } finally {
//       setLoading(false);
//     }
//   };

//   useFocusEffect(
//     React.useCallback(() => {
//       handleGetAllTeams();
//     }, [user])
//   );

//   const handleSelectTeam = (i) => {
//     dispatch({
//       type: SELECTED_TEAM,
//       payload: teamData[i],
//     });
//   };

//   useEffect(() => {
//     if (selectedTeam && selectedTeam.teamId) {
//       props.navigation.navigate("UserDrawerNavigator");
//     }
//   }, [selectedTeam]);

//   const handleLogout = () => {
//     props.navigation.navigate("AuthNavigator");
//     dispatch({ type: "LOGOUT" });
//   };

//   return (
//     <ImageBackground
//       source={require("../../../assets/images/player2.jpg")}
//       style={styles.container}
//     >
//       <View style={{ ...styles.container, backgroundColor: "rgba(0,0,0,0.8)" }}>
//         <StatusBar backgroundColor={Colors.darkBlue} />
//         <Image
//           source={require("../../../assets/icons/dashboard.png")}
//           style={styles.logo}
//         />

//         <Text style={styles.subTxt}>SELECT TEAM TO CONTINUE</Text>

//         <TouchableOpacity
//           style={styles.createBtnView}
//           onPress={() =>
//             props.navigation.navigate("CreateTeam", { handleGetAllTeams })
//           }
//        >
//           <View style={styles.plus}>
//             <Text style={styles.plustXT}>+</Text>
//           </View>
//           <Text style={styles.createTeamTxt}>Add team</Text>
//         </TouchableOpacity>

//         <View style={{ height: Dim.h * 0.5 }}>
//           <ScrollView
//              refreshControl={
//               <RefreshControl
//                 colors={[Colors.blue, Colors.white]}
//                 refreshing={loading}
//                 onRefresh={handleGetAllTeams}
//               />
//             }
//           >
// {teamData &&
//   teamData.map((v, i) => {
//     if (v.teamId) {
//       return (
//         <TouchableOpacity
//           key={i}
//           onPress={() => handleSelectTeam(i)}
//           style={styles.teamBtn}
//         >
//           <Text numberOfLines={1} style={styles.teamBtnTxt}>
//             {v.teamId.teamName}
//           </Text>
//           <Entypo
//             name="chevron-right"
//             size={25}
//             color={Colors.white}
//           />
//         </TouchableOpacity>
//       );
//     }
//   })}
//           </ScrollView>
//         </View>

//         <TouchableOpacity onPress={handleLogout} style={styles.logOutView}>
//           <Image
//             style={styles.logoutLogo}
//             source={require("../../../assets/icons/logout.png")}
//           />
//           <Text style={styles.logOutTxt}>Log Out</Text>
//         </TouchableOpacity>
//       </View>
//     </ImageBackground>
//   );
// };

// export default SelectTeam;

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     backgroundColor: Colors.white,
//   },
//   logo: {
//     width: Dim.w * 0.4,
//     height: Dim.w * 0.21,
//     alignSelf: "center",
//     marginTop: Dim.w * 0.15,
//     tintColor: Colors.white,
//   },
//   subTxt: {
//     fontSize: Dim.h * 0.04,
//     fontFamily: Fonts.heading,
//     color: Colors.white,
//     alignSelf: "center",
//     marginTop: Dim.w * 0.1,
//   },
//   teamBtn: {
//     width: Dim.w * 0.78,
//     height: Dim.h * 0.075,
//     backgroundColor: Colors.darkBlue,
//     borderRadius: 15,
//     marginBottom: 10,
//     alignItems: "center",
//     justifyContent: "space-between",
//     alignSelf: "center",
//     flexDirection: "row",
//     paddingHorizontal: Dim.w * 0.03,
//     paddingLeft: Dim.w * 0.05,
//   },
//   teamBtnTxt: {
//     fontSize: Dim.h * 0.025,
//     fontFamily: Fonts.medium,
//     color: Colors.white,
//     // textTransform: 'capitalize',
//   },
//   createBtnView: {
//     flexDirection: "row",
//     alignItems: "center",
//     alignSelf: "center",
//     marginVertical: Dim.w * 0.05,
//   },
//   plus: {
//     borderWidth: 1.5,
//     borderColor: Colors.red,
//     borderRadius: 100,
//     paddingTop: Dim.h * 0.005,
//     paddingBottom: Dim.h * 0.003,
//     paddingHorizontal: Dim.h * 0.008,
//     marginRight: 5,
//   },
//   plustXT: {
//     color: Colors.red,
//     fontSize: Dim.h * 0.02,
//     lineHeight: Dim.h * 0.02,
//     fontFamily: Fonts.bold,
//   },
//   createTeamTxt: {
//     fontSize: Dim.h * 0.02,
//     fontFamily: Fonts.medium,
//     color: Colors.red,
//   },
//   logOutView: {
//     flexDirection: "row",
//     alignItems: "center",
//     justifyContent: "center",
//     marginBottom: 15,
//     marginLeft: -5,
//     width: Dim.w * 0.4,
//     height: Dim.h * 0.06,
//     backgroundColor: Colors.white,
//     alignSelf: "center",
//     position: "absolute",
//     bottom: Dim.h * 0.01,
//     borderRadius: 15,
//   },
//   logoutLogo: {
//     marginRight: 5,
//     width: Dim.h * 0.03,
//     height: Dim.h * 0.03,
//   },
//   logOutTxt: {
//     fontSize: Dim.h * 0.02,
//     color: Colors.darkBlue,
//     fontFamily: Fonts.medium,
//   },
// });

import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserAllSubscriptions } from "../../../services/user.services";
import { SELECTED_TEAM } from "../../../redux/actions/teamActions";
import { useHistory } from "react-router-dom";
import mainImg from '../assets/dashboard.png'
import './selectTeam.css';

const SelectTeam = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [teamData, setTeamData] = useState(null);
  const [loading, setLoading] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const selectedTeam = useSelector((state) => state.team.selectedTeam);

  const handleGetAllTeams = useCallback(async () => {
    if (!user) return;

    try {
      setLoading(true);
      const response = await getUserAllSubscriptions(
        { userId: user._id },
        user?.token
      );
      setTeamData(response.data);
    } catch (error) {
      console.error("Failed to fetch teams:", error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      handleGetAllTeams();
    }
  }, [user, handleGetAllTeams]);

  const handleSelectTeam = (i) => {
    console.log("Team selected:", teamData[i]); // Debugging
    dispatch({
      type: SELECTED_TEAM,
      payload: teamData[i],
    });
  };

  useEffect(() => {
    console.log("selectedTeam updated:", selectedTeam); // Debugging
    if (selectedTeam && selectedTeam.teamId) {
      console.log("Navigating to dashboard with team name:", selectedTeam.teamId.teamName);
      history.push({
        pathname: "/userdashboard",
        state: { teamName: selectedTeam.teamId.teamName },
      });
    }
  }, [selectedTeam, history]);
  const handleLogout = () => {
    history.push("/auth-navigator");
    dispatch({ type: "LOGOUT" });
  };

  return (
    <div className="mainBackground">
      <div className='imageBox'>
      <img src={mainImg} className="headerImage" />
   </div>
      <h1 className="title">SELECT TEAM TO CONTINUE</h1>

      <div className="teamsButton">
        <div className="teamsMain">
          <div className="featuredContainer">
            {loading ? (
              <p style={{color:"white"}}>Loading teams...</p>
            ) : (
              <div className="allTeams">
                {teamData && teamData.map((v, i) => (
            v.teamId && (
              <div
                key={i}
                className="teamContainer"
                onClick={() => handleSelectTeam(i)}
              >
                <span className="allTeamName">{v.teamId.teamName} </span>
                <span style={{color: 'white'}} className="arrow">{'\u2192'}</span>
              </div>

            )
          ))}

                {/* {teamData &&
                  teamData.map((v, i) => {
                    if (v.teamId) {
                      return (
                        <div
                          key={i}
                          onClick={() => handleSelectTeam(i)}
                          className="teamBtn"
                        >
                          <span className="teamBtnTxt">
                            {v.teamId.teamName}
                          </span>
                        </div>
                      );
                    }
                    return null;
                  })} */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTeam;
